import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

export function JobCard({ job, dark }) {
  const salaryText = () => {
    if (job.salary_type === "R" && job.minsalary)
      return `${job.jobcur} ${job.minsalary}–${job.maxsalary} / ${job.salary_unit}`;
    if (job.salary_type === "F" && job.minsalary)
      return `${job.jobcur} ${job.minsalary} / ${job.salary_unit}`;
    return "Negotiable";
  };

  const cardClass = "sf-job-card" + (dark ? " sf-job-card-dark" : "");

  return (
    <div className={cardClass}>
      <div className="sf-job-card-top">
        <Link to={"/company/" + job.clientslug} className="sf-job-logo">
          <img
            src={job.photo ? "/uploads/emp_img/" + job.photo : "/default/default_company_logo.jpg"}
            alt={job.comp_name}
          />
        </Link>
        <div style={{ minWidth: 0 }}>
          <Link to={"/jobs/" + job.slug} className="sf-job-title">
            {job.job_title}
          </Link>
          <Link to={"/company/" + job.clientslug} className="sf-job-company">
            {job.comp_name}
          </Link>
        </div>
      </div>
      <div className="sf-job-meta trend-exp-meta">
          <span className="sf-job-meta-item">
            <i className="fa fa-clock" /> {moment(job.created_at).fromNow()}
          </span>
        {job.job_location && (
          <span className="sf-job-meta-item">
            <i className="fa fa-map-marker" /> {job.job_location && job.job_location.length > 25
              ? `${job.job_location.substring(0, 25)}...`
              : job.job_location}
          </span>
        )}
        {job.job_type && (
          <span className="sf-job-meta-item">
            <i className="fa fa-building-o" /> {job.job_type}
          </span>
        )}
      </div>

      {/* {job.work_type && (
        <div className="sf-job-badges">
          <span className={"sf-badge " + (dark ? "sf-badge-white" : "sf-badge-blue")}>
            {job.work_type}
          </span>
        </div>
      )} */}

      <div className="sf-job-footer">
        <span className="sf-job-meta-item">
          {salaryText()}
          </span>
        {/* <Link to={"/jobs/" + job.slug} className="sf-job-browse">
          Browse Job
        </Link> */}
      </div>
    </div>
  );
}

export function TrendingJobCard({ job, dark }) {
  const salaryText = () => {
    if (job.salary_type === "R" && job.minsalary)
      return `${job.jobcur} ${job.minsalary}–${job.maxsalary} / ${job.salary_unit}`;
    if (job.salary_type === "F" && job.minsalary)
      return `${job.jobcur} ${job.minsalary} / ${job.salary_unit}`;
    return "Negotiable";
  };

  const ExperienceText = () => {
    if (job.experience_type === "F") return "Freshers";
    if (job.experience_type === "E") {
      const minExp = job.min_exp ? `${job.min_exp} ${job.min_exp_unit || "years"}` : "";
      const maxExp = job.max_exp ? `${job.max_exp} ${job.exp_unit || "years"}` : "";
      if (minExp && maxExp) {
        return `${minExp} - ${maxExp}`;
      }else if (minExp) {        return `${minExp}+`;
      } else if (maxExp) {
        return `Up to ${maxExp}`;
      }
      return  "Experienced";
    }
    return "Not Specified";
  }

  const JobLevelText = () => {
    if (job.job_level) return job.job_level;
    return "Not Specified";
  }

  const cardClass = "sf-job-card" + (dark ? " sf-job-card-dark" : "");

  return (
    <div className={cardClass}>
      <div className="sf-job-card-top">
        <Link to={"/company/" + job.clientslug} className="sf-job-logo">
          <img
            src={job.photo ? "/uploads/emp_img/" + job.photo : "/default/default_company_logo.jpg"}
            alt={job.comp_name}
          />
        </Link>
        <div style={{ minWidth: 0 }}>
          <Link to={"/jobs/" + job.slug} className="sf-job-title">
            {job.job_title}
          </Link>
          <Link to={"/company/" + job.clientslug} className="sf-job-company">
            {job.comp_name}
          </Link>
        </div>
      </div>
      <div className="sf-job-meta trend-exp-meta">
          <span className="sf-job-meta-item">
            <i className="fa fa-briefcase" /> {ExperienceText()}
          </span>
          <span className="sf-job-meta-item">
            <i className="fa fa-building-o" /> {JobLevelText()}
          </span>
          <span className="sf-job-meta-item">
            <i className="fa fa-money" /> {salaryText()}
          </span>
        {/* {job.job_location && (
          <span className="sf-job-meta-item">
            <i className="fa fa-map-marker" /> {job.job_location && job.job_location.length > 25
              ? `${job.job_location.substring(0, 25)}...`
              : job.job_location}
          </span>
        )} */}
        {/* {job.job_type && (
          <span className="sf-job-meta-item">
            <i className="fa fa-building-o" /> {job.job_type}
          </span>
        )} */}
      </div>

      {/* {job.work_type && (
        <div className="sf-job-badges">
          <span className={"sf-badge " + (dark ? "sf-badge-white" : "sf-badge-blue")}>
            {job.work_type}
          </span>
        </div>
      )} */}

      <div className="sf-job-footer">
        <span className="sf-job-meta-item">
           <i className="fa fa-calendar-o" /> {job.apply_before ? `Apply before: ${moment(job.apply_before).format("MMM D, YYYY")}` : "No deadline"}
          </span>
        {/* <Link to={"/jobs/" + job.slug} className="sf-job-browse">
          Browse Job
        </Link> */}
      </div>
    </div>
  );
}

export function RelatedJobsCard({ job, dark }) {
  // const salaryText = () => {
  //   if (job.salary_type === "R" && job.minsalary)
  //     return `${job.jobcur} ${job.minsalary}–${job.maxsalary} / ${job.salary_unit}`;
  //   if (job.salary_type === "F" && job.minsalary)
  //     return `${job.jobcur} ${job.minsalary} / ${job.salary_unit}`;
  //   return "Negotiable";
  // };

  // const ExperienceText = () => {
  //   if (job.experience_type === "F") return "Freshers";
  //   if (job.experience_type === "E") {
  //     const minExp = job.min_exp ? `${job.min_exp} ${job.min_exp_unit || "years"}` : "";
  //     const maxExp = job.max_exp ? `${job.max_exp} ${job.exp_unit || "years"}` : "";
  //     if (minExp && maxExp) {
  //       return `${minExp} - ${maxExp}`;
  //     }else if (minExp) {        return `${minExp}+`;
  //     } else if (maxExp) {
  //       return `Up to ${maxExp}`;
  //     }
  //     return  "Experienced";
  //   }
  //   return "Not Specified";
  // }

  // const JobLevelText = () => {
  //   if (job.job_level) return job.job_level;
  //   return "Not Specified";
  // }
  const ExpiryText = () => {
    if (job.expiry_data === "Expired") {
      return <div className="text-danger"><i className="fa fa-calendar-o"></i> Job Expired</div>;
    }
    else {      return <div classname="text-clr-purple"><i className="fa fa-calendar-o"></i> {job.expiry_data} remaining</div>;
    }
  }

  const cardClass = "related-job-card" + (dark ? " sf-job-card-dark" : "");

  return (
    <div className={cardClass}>
      <div className="related-job-card-dtl">
        <Link to={"/company/" + job.clientslug} className="company_logo">
          <img
            src={job.imgUrl ? job.imgUrl : "/default/default_company_logo.jpg"}
            alt={job.comp_name}
          />
        </Link>
        <div className="job_ttl_com_name" style={{ minWidth: 0 }}>
          <Link to={"/jobs/" + job.slug} className="sf-job-title">
            {job.job_title}
          </Link>
          <Link to={"/company/" + job.clientslug} className="sf-job-company">
            {job.comp_name}
          </Link>
          <span className="sf-job-meta-item">
           {ExpiryText()} 
          </span>
        </div>
      </div>
      {/* <div className="sf-job-meta related-exp-meta">

        <span className="sf-job-meta-item">
           {ExpiryText()} 
          </span>
      </div> */}

      {/* <div className="sf-job-footer">
        <span className="sf-job-meta-item">
           <i className="fa fa-calendar-o" /> {job.apply_before ? `Apply before: ${moment(job.apply_before).format("MMM D, YYYY")}` : "No deadline"}
          </span>
      </div> */}
    </div>
  );
}

export function SameCompanyJobsCard({ job, dark }) {
  const salaryText = () => {
    if (job.salary_type === "R" && job.minsalary)
      return `${job.jobcur} ${job.minsalary}–${job.maxsalary} / ${job.salary_unit}`;
    if (job.salary_type === "F" && job.minsalary)
      return `${job.jobcur} ${job.minsalary} / ${job.salary_unit}`;
    return "Negotiable";
  };

  // const ExperienceText = () => {
  //   if (job.experience_type === "F") return "Freshers";
  //   if (job.experience_type === "E") {
  //     const minExp = job.min_exp ? `${job.min_exp} ${job.min_exp_unit || "years"}` : "";
  //     const maxExp = job.max_exp ? `${job.max_exp} ${job.exp_unit || "years"}` : "";
  //     if (minExp && maxExp) {
  //       return `${minExp} - ${maxExp}`;
  //     }else if (minExp) {        return `${minExp}+`;
  //     } else if (maxExp) {
  //       return `Up to ${maxExp}`;
  //     }
  //     return  "Experienced";
  //   }
  //   return "Not Specified";
  // }

  // const JobLevelText = () => {
  //   if (job.job_level) return job.job_level;
  //   return "Not Specified";
  // }
  const ExpiryText = () => {
    if (job.expiry_data === "Expired") {
      return <div className="text-danger"><i className="fa fa-calendar-o"></i> Job Expired</div>;
    }
    else {      return <div classname="text-clr-purple"><i className="fa fa-calendar-o"></i> {job.expiry_data} remaining</div>;
    }
  }

  const cardClass = "related-job-card" + (dark ? " sf-job-card-dark" : "");

  return (
    <div className={cardClass}>
      <div className="related-job-card-dtl">
        <Link to={"/company/" + job.clientslug} className="company_logo">
          <img
            src={job.imgUrl ? job.imgUrl : "/default/default_company_logo.jpg"}
            alt={job.comp_name}
          />
        </Link>
        <div className="job_ttl_com_name" style={{ minWidth: 0 }}>
          <Link to={"/jobs/" + job.slug} className="sf-job-title">
            {job.job_title}
          </Link>
          <span className="sf-job-meta-item">
            {salaryText()}
          </span>
          <span className="sf-job-meta-item">
           {ExpiryText()} 
          </span>
        </div>
      </div>
      {/* <div className="sf-job-meta related-exp-meta">

        <span className="sf-job-meta-item">
           {ExpiryText()} 
          </span>
      </div> */}

      {/* <div className="sf-job-footer">
        <span className="sf-job-meta-item">
           <i className="fa fa-calendar-o" /> {job.apply_before ? `Apply before: ${moment(job.apply_before).format("MMM D, YYYY")}` : "No deadline"}
          </span>
      </div> */}
    </div>
  );
}

export default function JobsList({ title, size, extraParams }) {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedGroup, setExpandedGroup] = useState(null);

  const perPage = size || 20;
  const extra = extraParams || {};

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const params = new URLSearchParams({ per_page: perPage, service_type: "hot-jobs", ...extra });
    // console.log('🔵 JobsList: Fetching jobs from:', constvar.api_url + "jobs/grouped?" + params.toString());
    
    axios
      .get(constvar.api_url + "jobs/grouped?" + params.toString(), {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        // console.log('🟢 JobsList: API Response:', res.data);
        if (res.data.status === "success") {
          const jobsData = res.data.data.data || [];
          // console.log('🟢 JobsList: Setting employers array with', jobsData.length, 'groups');
          setEmployers(jobsData);
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("❌ JobsList: Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [perPage, JSON.stringify(extra)]);

  const handleGroupHover = (groupId) => {
    setExpandedGroup(groupId);
  };

  const handleGroupLeave = () => {
    setExpandedGroup(null);
  };

  return (
    <section className="sf-section">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">{title}</h2>
          <Link to="/job_search" className="sf-section-link">
            View All
          </Link>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : employers.length > 0 ? (
          <div className="sf-groupby-employers-grid">
            {employers.map((employer) => {
              // Determine if this is an employer or newspaper group
              const isEmployerGroup = employer.employer_id !== null;
              const groupId = isEmployerGroup ? employer.employer_id : employer.newspaper_id;
              const displayName = isEmployerGroup ? employer.comp_name : employer.newspaper_name;
              const companySlug = isEmployerGroup ? employer.clientslug : null;

              // Debug: Log to see what's being set
              // console.log('Group:', { groupId, isEmployerGroup, displayName, comp_name: employer.comp_name, newspaper_name: employer.newspaper_name });

              const isExpanded = expandedGroup === groupId;
              const visibleJobs = isExpanded ? employer.jobs.slice(0, 7) : employer.jobs.slice(0, 2);
              const hasMoreJobs = employer.jobs.length > 2;
              const remainingCount = employer.jobs.length - 2;

              return (
                <div className="jobs_card">
                  <div
                    key={groupId}
                    className={`sf-groupby-employer-card ${isExpanded ? "sf-groupby-employer-card-expanded" : ""}`}
                    onMouseEnter={() => handleGroupHover(groupId)}
                    onMouseLeave={handleGroupLeave}
                  >
                    <div className="flex justify-between">
                      {/* Employer/Newspaper Header */}
                      <div className="sf-groupby-employer-header">
                        <div className="sf-groupby-employer-logo-wrapper">
                          <img
                            src={
                              employer.photo ||
                              "/default/default_company_logo.jpg"
                            }
                            alt={displayName}
                            className="sf-groupby-employer-logo"
                          />
                        </div>
                        <div className="sf-groupby-employer-name">
                          <h5>
                            {isEmployerGroup ? (
                              <Link key={groupId} to={`/company/${companySlug}`} className="sf-groupby-employer-name-link">
                                {displayName || "N/A"}
                              </Link>
                            ) : (
                              <span className="sf-groupby-employer-name-link">
                                {displayName || "N/A"}
                              </span>
                            )}
                          </h5>
                          {visibleJobs.map((job) => (
                            <Link
                              key={job.id}
                              to={"/jobs/" + job.slug}
                              className="sf-groupby-employer-job-link"
                            >
                                {job.job_title.length > 25 
                                  ? `${job.job_title.substring(0, 25)}...` 
                                  : job.job_title
                                }
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* Expand Button - Show only if more than 2 jobs and is employer group */}
                      {hasMoreJobs  && (
                        <div className="sf-groupby-employer-expand-button">
                          <Link key={groupId} to={`/company/${companySlug}`}>
                          <span className="sf-groupby-expand-text">
                          +{remainingCount} more
                          </span>
                          <i className="fa fa-chevron-down" />
                          </Link>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="sf-empty">No jobs available at the moment.</div>
        )}
      </div>
    </section>
  );
}
